/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrate`)
};

const es_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrar`)
};

const de_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalibrieren`)
};

const nl_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalibreren`)
};

const fr_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrer`)
};

const it_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibra`)
};

const pt_br2_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrar`)
};

const pt_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calibrar`)
};

const ja_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校正`)
};

const zh_ruler_calibrate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校准`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_calibrate = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_calibrate(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_calibrate", locale)
	if (locale === "en") return en_ruler_calibrate(inputs)
	if (locale === "es") return es_ruler_calibrate(inputs)
	if (locale === "de") return de_ruler_calibrate(inputs)
	if (locale === "nl") return nl_ruler_calibrate(inputs)
	if (locale === "fr") return fr_ruler_calibrate(inputs)
	if (locale === "it") return it_ruler_calibrate(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_calibrate(inputs)
	if (locale === "pt") return pt_ruler_calibrate(inputs)
	if (locale === "ja") return ja_ruler_calibrate(inputs)
	return zh_ruler_calibrate(inputs)
};